module.exports = __webpack_public_path__ + "img/buissonniere-e-commerce-success-story.c9aed4c5.webp";